import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, of, Subject } from 'rxjs';

@Component({
  selector: 'app-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.scss'],
  // encapsulation: ViewEncapsulation.ShadowDom
})
export class ModalContentComponent implements OnInit, OnDestroy {
  private eventEmmiter: Subject<any> = new Subject();
  onEvent: Observable<any> = of(null);

  @Input() loading$: Observable<boolean> = of(true);


  constructor(
    public dialogRef: MatDialogRef<ModalContentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  submit() {
    this.eventEmmiter.next('submit');
  }

  ngOnInit() {
    this.eventEmmiter = new Subject();
    this.onEvent = this.eventEmmiter.asObservable();
  }

  ngOnDestroy(): void {
    this.eventEmmiter.unsubscribe();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
